import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import { service } from '@ember/service';
import type StoreService from 'scaleflow/services/store';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';

type Model = {
  department_id: string;
};

class CompanyDepartmentRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;

  model({ department_id }: Model) {
    return this.store.findRecord('department', department_id);
  }

  @action
  error(error: any) {
    if (error.code === 'NotFoundError') {
      this.router.replaceWith('company');
      return;
    } else {
      // Let the route above this handle the error.
      return true;
    }
  }
}

export default instrumentRoutePerformance(CompanyDepartmentRoute);
